/* eslint one-var: "off" */
export const ALL_CATEGORIES = -1;
export const CATEGORY_CREDIT_PERCENTS = 65;
export const CATEGORY_APPLIANCES = 1;
export const CATEGORY_CASH = 2;
export const CATEGORY_HEALTH = 4;
export const CATEGORY_CAFE = 5;
export const CATEGORY_COMMUNAL = 6;
export const CATEGORY_CLOTHES = 7;
export const CATEGORY_TRANSFERS = 8;
export const CATEGORY_MOBILE = 9;
export const CATEGORY_FOOD = 10;
export const CATEGORY_OTHER = 11;
export const CATEGORY_ENTERTAINMENT = 12;
export const CATEGORY_CAR = 13;
export const CATEGORY_BUILDING = 14;
export const CATEGORY_TOURISM = 15;
export const CATEGORY_FUEL = 17;
export const CATEGORY_DEPOSIT = 100000000000896;
